export default "__VITE_ASSET__CxT09EVK__"